import React, { useEffect, useState } from "react";
import logo from '../../Assests/6cc50dfbdb85cec604c94e003196fcb318fb231a.png'
import './Nav.css'
import { NavLink, useLocation } from "react-router-dom";

function Nav() {
    const location = useLocation();
    const isOnCollecciones = location.pathname === "/Collecciones";

    const [hasBackground, setHasBackground] = useState(isOnCollecciones);
    const [scrolled, setScrolled] = useState(isOnCollecciones);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 856);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {

        if (location.pathname === "/Collecciones") {
            setHasBackground(true);
            setScrolled(true);
        } else {
            // Solo resetear si no estamos scrolleando
            if (window.scrollY <= 10) {
                setHasBackground(false);
                setScrolled(false);
            }
        }

        const handleScroll = () => {
            if (window.scrollY > 10 || isOnCollecciones) {
                setHasBackground(true);
                setScrolled(true);
            } else {
                setHasBackground(false);
                setScrolled(false);
            }
        };

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 856);
            if (window.innerWidth > 856) {
                setMenuOpen(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [isOnCollecciones, location.pathname]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div className={`navContainer ${hasBackground ? 'navScrolled' : ''}`}>
            {isMobile ? (
                <>
                    <div className="hamburger-menu" onClick={toggleMenu}>
                        <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
                        <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
                        <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
                    </div>
                    <div className={`mobile-menu-container ${menuOpen ? 'open' : ''}`}>
                        <div className="mobile-menu-content">
                            <NavLink to="/Inicio" className='activeNavLog' onClick={toggleMenu}>
                                <img src={logo} alt="Logo" className="mobile-logo" />
                            </NavLink>
                            <NavLink to="/Collecciones" className='activeNav' onClick={toggleMenu}>
                                <p className="optionsNav">COLECCIONES</p>
                            </NavLink>
                            <NavLink to="/Fabrica" className='activeNav' onClick={toggleMenu}>
                                <p className="optionsNav">FABRICA</p>
                            </NavLink>
                            <NavLink to="/Sobre_nosotros" className='activeNav' onClick={toggleMenu}>
                                <p className="optionsNav">CONÓCENOS</p>
                            </NavLink>
                            <NavLink to="/Inicio" className='activeNav' onClick={toggleMenu}>
                                <p className="optionsNav">INICIO</p>
                            </NavLink>
                            <NavLink to="/Contactanos" className='activeNav' onClick={toggleMenu}>
                                <p className="optionsNav">CONTACTO</p>
                            </NavLink>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="optionsLeftContainer">
                        <NavLink to="/Collecciones" className='activeNav'>
                            <p className="optionsNav">COLECCIONES</p>
                        </NavLink>
                        <NavLink to="/Fabrica" className='activeNav'>
                            <p className="optionsNav">FABRICA</p>
                        </NavLink>
                        <NavLink to="/Sobre_nosotros" className='activeNav'>
                            <p className="optionsNav">CONOCENOS</p>
                        </NavLink>
                    </div>
                    <div className="logoContainer">
                        <NavLink to="/Inicio" className='activeNavLog'>
                            <img src={logo} alt="logo" className={`logoNavContainer ${scrolled ? 'logoScrolled' : ''}`} />
                        </NavLink>
                    </div>
                    <div className="optionsRightContainer">
                        <NavLink to="/Inicio" className='activeNav'>
                            <p className="optionsNav">INICIO</p>
                        </NavLink>
                        <NavLink to="/Contactanos" className='activeNav'>
                            <p className="optionsNav">CONTACTO</p>
                        </NavLink>
                    </div>
                </>
            )}
        </div>
    )
}

export default Nav;
